/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BonusBunniesReelController} from "../../reel/BonusBunniesReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {BonusBunniesLogo} from "../../logo/BonusBunniesLogo";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesFreeSpinIntroController} from "../freespinintro/BonusBunniesFreeSpinIntroController";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";

export class BonusBunniesFreeSpinOutroController extends FreespinOutroController {

    private static _totalWin:number;

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected hideKeypad() {

    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        if(data.freespinsLeft == 0 && data.mode == BonusBunniesGameMode.BONUS_GAME && data.nextMode == BonusBunniesGameMode.NORMAL) {
            return true;
        } else {
            return false;
        }
        BonusBunniesFreeSpinOutroController._totalWin = data.totalWin;
    }

    protected close():void {
        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.CONTINUE_BUTTON_CLICK);
        super.close();
    }

    protected onCloseComplete():void {
        super.onCloseComplete();
        BonusBunniesGameModuleConfig.featurePrice.reset();
    }

    public start():void {
        BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.retriggerAnimation = false;
        super.start();
    }

    private static disableBonusGameExtraReel():void {
        (<BonusBunniesReelController>Reels.getReel(4)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(9)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(14)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(19)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(20)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(21)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(22)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(23)).view.visible = false;
        (<BonusBunniesReelController>Reels.getReel(24)).view.visible = false;
    }

    private static cleanupReels():void{
        for(let i:number = 0; i < 25; i++) {
            let reel:(StateReelSymbol | null)[] = Reels.allSymbols(i);
            for(let j:number = 0; j < reel.length; j++) {
                reel[j]!.replaceWith("L" + (MathHelper.randomIntInRange(1, 5)), j);
            }
        }
    }

    private static setBaseGameReelStopSounds():void {
        BonusBunniesSoundConfig.instance.REELS_DEFAULT_BOUNCE = [];
        for(let i:number = 0; i < BonusBunniesSoundConfig.instance.REELS_BASE_GAME_BOUNCE.length; i++) {
            BonusBunniesSoundConfig.instance.REELS_DEFAULT_BOUNCE.push(BonusBunniesSoundConfig.instance.REELS_BASE_GAME_BOUNCE[i]);
        }
    }

    private static clearAllReelsStopDelay():void {
        for(let i:number = 0; i < BonusBunniesGameConfig.instance.REELS_NUM; i++) {
            (<BonusBunniesReelController>Reels.getReel(i)).resetStopDelay();
        }
    }

    public static actuallyDoTransition() {
        BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.abortZeppelinanimation();
        BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.retriggerAnimation = true;
        BonusBunniesGameModuleConfig.bonusBunniesZeppelinController.restartZeppelinAnimation();
        BonusBunniesFreeSpinOutroController.clearAllReelsStopDelay();
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : BonusBunniesGameMode.NORMAL}));
        BonusBunniesFreeSpinOutroController.setBaseGameReelStopSounds();
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.disableBonusGameMode();
        BonusBunniesGameModuleConfig.bonusBunniesLayerController.restoreZoom();
        BonusBunniesGameModuleConfig.bonusBunniesBottomRowWPController.disableExtraRow();
        BonusBunniesGameModuleConfig.bonusBunniesExtraReelWPController.disableExtraReel();
        BonusBunniesFreeSpinOutroController.cleanupReels();
        BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.cleanupStickyBonusValues();
        BonusBunniesGameModuleConfig.bonusBunniesB5WinView.removeB5Win();
        BonusBunniesGameModuleConfig.bonusBunniesSpinController.resetBonusReelsToSpin();
        BonusBunniesFreeSpinOutroController.disableBonusGameExtraReel();
        BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.restore();
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterView.extraReelActivated = false;
        BonusBunniesGameModuleConfig.bonusBunniesBonusMultiplierWPView.extraReelActivated = false;
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.setExtraReelActivated(false);
        BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsChestController.setExtraRowActivated(false);
        BonusBunniesGameModuleConfig.bonusBunniesReelAreaView.enable30LinesPicture();
        BonusBunniesGameModuleConfig.bonusBunniesBonusGameInfoPlate.disableInfo();
        BonusBunniesLogo.bonusBunniesLogo.enableLogo();
        SlotGame.winFieldController.showWinField(this._totalWin, false, true);
    }
}